import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { IHookCallbacks } from 'src/hooks/common.hooks.interfaces';
import { GET_DOCUMENTS_LABELS_BY_COMPANY } from 'src/hooks/documents-labels/get-documents-labels.hook';

import { GET_DOCUMENT_TEMPLATE_BY_ID } from './get-document-template-by-id.hook';

export const UPDATE_DOCUMENT_TEMPLATE = gql`
  mutation updateDocumentTemplate($payload: UpdateDocumentTemplateInput!) {
    updateDocumentTemplate(payload: $payload) {
      _id
    }
  }
`;

export const useUpdateDocumentTemplate = ({ onSuccess }: IHookCallbacks) => {
  const { t } = useTranslation('common');
  const [updateDocumentTemplate] = useMutation(UPDATE_DOCUMENT_TEMPLATE, {
    refetchQueries: [GET_DOCUMENTS_LABELS_BY_COMPANY, GET_DOCUMENT_TEMPLATE_BY_ID],
    onCompleted: onSuccess,
    onError: (error: any) => {
      if (error && error.message) {
        const [errorKey, errorDetail] = error.message.split('-');

        return showNotification({
          type: NOTIFICATION_TYPE.error,
          message: t(`settings:documents.errors.${errorKey}`, { detail: errorDetail }),
        });
      }

      return showNotification({
        type: NOTIFICATION_TYPE.error,
        message: t('common:notifications.error.title'),
        ...(error && { description: error.errorMessage }),
      });
    },
  });

  return updateDocumentTemplate;
};
